import { render, staticRenderFns } from "./EditInvitationModal.vue?vue&type=template&id=254d1ad8&"
import script from "./EditInvitationModal.vue?vue&type=script&lang=ts&"
export * from "./EditInvitationModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditInvitationModal.vue?vue&type=style&index=0&id=254d1ad8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports